import { EventEmitter } from 'events';

const emitter = new EventEmitter();

emitter.setMaxListeners(20);

export const navigateTo = (path: string) => {
  if (typeof window === 'undefined') return;

  requestAnimationFrame(() => {
    emitter.emit('navigate', path);
  });
};

export const onNavigate = (listener: (path: string) => void) => {
  emitter.on('navigate', listener);

  return () => {
    emitter.off('navigate', listener);
  };
};
